/* src/app/main/claim-data/create/create-claim-data-batch.component.scss */
.custom-file-label {
  padding: 0.5em;
  font-size: 1em;
  display: inline-block;
  color: black;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  word-break: break-all;
  white-space: normal;
  min-height: 1.5em;
  box-sizing: border-box;
}
.custom-file-label:focus {
  outline-color: #006f8a;
  outline-offset: -1px;
  outline-width: 1px;
  outline-style: solid;
}
custom-file-label:-webkit-autofill,
custom-file-label:-webkit-autofill:hover,
custom-file-label:-webkit-autofill:focus,
custom-file-label:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: black !important;
}
custom-file-label:-moz-autofill {
  background-color: white !important;
  color: black !important;
}
custom-file-label:-ms-input-placeholder {
  background-color: white !important;
  color: black !important;
}
.custom-file-input {
  display: none;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
th {
  background-color: #004c8c;
  color: white;
  font-weight: bold;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
tr:hover {
  background-color: #ddd;
}
.input-group input {
  width: 100px;
  padding: 5px;
  margin-right: 5px;
}
button.button:disabled {
  opacity: 0.7;
  pointer-events: none;
  cursor: not-allowed;
  border-color: rgba(0, 0, 0, 0.2);
}
button.button.button-progress {
  position: relative;
  overflow: hidden;
  min-width: 260px;
  color: #004f65;
  border-color: #006f8a;
  background:
    linear-gradient(
      to right,
      #b2d8e3 var(--progress, 0%),
      white var(--progress, 0%));
  transition: background 0.4s ease;
  cursor: default;
}
button.button.button-progress .progress-percent {
  font-weight: 700;
  margin-right: 6px;
}
/*# sourceMappingURL=create-claim-data-batch.component-ELBHDBET.css.map */
